import React from 'react'
import CustomTooltip from '../../CustomTooltip'
import BigInfoIcon from '../../components/Images/BigInfoIcon'
import { RevenueCardMobTitle, RevenueCardContainer, RevenueCardTitle, RevenueCardValue, ToolTipContainerRight } from './style'
import { handleEventLog } from '../../lib/utils'

export default function RevenueCards({
  title,
  showCurrency,
  ToastTxt,
  value,
  isMobile,
  bookSelected = '',
  module = ''
}) {
  const sendTooltipAnalyticsDataHandler = () => {
    handleEventLog('analytics_revenue', 'button_click', {
      show_id: bookSelected,
      module_name: module,
    })
  }

  return (
    <RevenueCardContainer style={{ width: `${isMobile ? '100%' : '25%'}` }}>
      <div>
        {isMobile && (
          <div style={{ float: 'left', marginTop: '4px' }}>
            <CustomTooltip content={ToastTxt} direction="right">
              <BigInfoIcon
                width={16}
                height={16}
                onClick={sendTooltipAnalyticsDataHandler}
              />
            </CustomTooltip>
          </div>
        )}
        {isMobile ? (
          <RevenueCardMobTitle>{title}</RevenueCardMobTitle>
        ) : (
          <RevenueCardTitle>{title}</RevenueCardTitle>
        )}
        {!isMobile && (
          <ToolTipContainerRight>
            <CustomTooltip content={ToastTxt} direction="left">
              <BigInfoIcon
                width={16}
                height={16}
                onClick={sendTooltipAnalyticsDataHandler}
              />
            </CustomTooltip>
          </ToolTipContainerRight>
        )}
      </div>
      <RevenueCardValue>{value}</RevenueCardValue>
    </RevenueCardContainer>
  )
}